// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"740fc971","6823":"740fc971","8967":"740fc971"}[chunkId] + ".chunk.css";
};